import React from "react";
function InternalDrawer({ isOpen, rootProps, children }) {
  return (
    <div
      className={`absolute top-0 bottom-0 right-0 min-h-[calc(100vh-90px)] max-h-max h-full ${
        isOpen ? "left-0" : "left-full"
      } transition-all duration-300 ease-linear ${
        rootProps?.bgColor ?? "bg-primary-500"
      }`}
    >
      <div
        className="flex flex-col bg-inherit"
        flexDir="column"
        bgColor="inherit"
      >
        {isOpen && children}
      </div>
    </div>
  );
}

export default React.memo(InternalDrawer);
